import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { Button, Dialog, DialogContent, DialogActions } from 'react-mdl'
import { checkNextPropsPromise, connectDefault } from '../utils/utils'
import { FacebookStepper } from './FacebookStepper'
import { SlackStepper } from './SlackStepper'
import { TelegramStepper } from './TelegramStepper'
import { SMSStepper } from './SMSStepper'
import { ChatWidgetStepper } from './ChatWidgetStepper'
import { AEmailStepper } from './AEmailStepper'
import * as actions from '../actions/index'
import * as styles from '../styles/styles'
import { ChannelConfigStepper } from './ChannelConfigStepper';

class ChannelPage extends Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    ahBaseUrl: PropTypes.string.isRequired,
    appJWT: PropTypes.string.isRequired,
    channelType: PropTypes.string.isRequired,
    channelTypes: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    fetchCredentials: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props,context) {
    super(props,context);

    const channelTypeConfig = this.props.channelTypes.filter(function(e) { return e.id === this.props.channelType}.bind(this))[0]
    if (channelTypeConfig === null) {
      this.state = {}
      return
    }

    const paramKeys = channelTypeConfig["params"].map(function(e) { return e["id"] })

    this.state = {
      channel: null,
      channelTypeConfig: channelTypeConfig,
      paramKeys: paramKeys,
      deleteChannelDialogVisible: false
    }

    this.channelAPI = this.props.channelAPI.bind(this);
    this.createChannel = this.createChannel.bind(this);
    this.deleteChannel = this.deleteChannel.bind(this);
    this.handleOpenDeleteChannelDialog = this.handleOpenDeleteChannelDialog.bind(this);
    this.handleCloseDialogs = this.handleCloseDialogs.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.channelCreated = this.channelCreated.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    this.setTopbarButtons(true)
    if (this.state.channelTypeConfig === undefined) {
      this.goBack()
    }
    else {
      this.props.fetchChannel()
    }
  }

  componentWillReceiveProps(nextProps) {
    //load of channel
    if (checkNextPropsPromise(this.props, nextProps, 'channel')) {
      if (nextProps.channel.fulfilled){
        const channel = nextProps.channel.value

        const channelsTitles = {}
        channelsTitles[channel.id] = this.headerForChannel(channel)
        this.props.dispatch(actions.addBreadcrumbsRouteTitles({'channel':channelsTitles}))

        this.setState({channel:channel})

        this.setTopbarButtons(false)
      }
    }
  }

  setTopbarButtons(addingChannel) {
    if (addingChannel) {
      this.props.dispatch(
        actions.setTopbarButtons([])
      )
    }
    else {
      this.props.dispatch(
        actions.setTopbarButtons([
          { key:"CHANNEL_DELETE", title: "Delete", icon: "delete", action: this.handleOpenDeleteChannelDialog }
        ])
      )
    }
  }

  headerForChannel(channel) {
    return channel.title ? channel.title : this.getChannelTypeName(channel)
  }

  getChannelTypeName(channel) {
    return this.state.channelTypeConfig["name"]
  }

  renderDialog() {
    return  <Dialog open={this.state.deleteChannelDialogVisible}>
              <DialogContent>
                <p>Are you sure you want to delete this channel?</p>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.deleteChannel} style={styles.button.delete}>Delete</Button>
                <Button onClick={this.handleCloseDialogs}>Cancel</Button>
              </DialogActions>
            </Dialog>
  }

  specialChannelClass() {
    const {channelType} = this.props
    switch (channelType) {
      case "ufbm" : return FacebookStepper;
      case "aslack" : return SlackStepper;
      case "utlg" : return TelegramStepper;
      case "ubxc" : return ChatWidgetStepper;
      case "usms" : return SMSStepper;
      case "aemail": return AEmailStepper;
      default: return null
    }
  }

  handleNextStep() {
    const { state } = this.channelConfigStepper
    const stepConfig = this.channelConfigStepper.activeStepConfig()

    if (stepConfig.save === "create" && !this.state.channel) {
      const channel = {}
      channel.title = state.title
      channel.params = {...state.params}

      this.createChannel(channel, (response, err) => {
                       if (!err) {
                         this.nextStep()
                       }
                       })
    }
    else if (stepConfig.save === "edit" && this.state.channel) {
      const channel = {...this.state.channel}
      channel.title = state.title
      channel.params = {...state.params}

      this.updateChannel(channel, (response, err) => {
                         if (!err) {
                          this.nextStep()
                         }
                         })
    }
    else {
      this.nextStep()
    }
  }

  nextStep() {
    if (this.channelConfigStepper.isLastStep()) {
      this.goBack()
    }
    else {
      this.channelConfigStepper.stepper.nextStep()
    }
  }

  render(){
    const {channelTypeConfig} = this.state

    const channel = this.state.channel
    const MyComponent = this.specialChannelClass()

    if (MyComponent !== null) {

      const {fetchChannelProviders, channelAPI, channelAPIResponse, fetch, fetchResponse, location, channelType, dispatch, fetchCredentials} = this.props
      const addingChannel = !(this.props.channel !== undefined && this.props.channel.fulfilled)

      const component = React.createElement(MyComponent, {channelType, channel, channelAPIResponse, fetchChannelProviders, channelAPI, createChannel:this.createChannel, updateChannel:this.props.putChannel, location, fetch, fetchResponse, goBack:this.goBack, addingChannel, dispatch:dispatch, fetchCredentials})

      return (
              <div>
              {this.renderDialog()}
              <h3>{channelTypeConfig.name}</h3>
              {component}
              </div>
              )
    }

    return (
      <div>
        {this.renderDialog()}
        <h3>{channelTypeConfig.name}</h3>
        <ChannelConfigStepper ref={(s) => this.channelConfigStepper = s} channelType={this.props.channelType} channel={channel} onBeforeNextStep={this.handleNextStep} />
      </div>
    )
  }

  // Form Actions

  deleteChannel() {
    this.props.deleteChannel(this.state.channel, (response, err) => {
                             if (!err) {
                               this.goBack()
                             }
                             })
  }

  createChannel(channel,handler) {
    channel.id = this.props.channelType
    this.props.postChannel(channel, (response, err) => {
                           if (!err) {
                             this.setState({channel:response})
                             this.channelCreated(channel)
                           }
                           if (handler) {
                             handler(response, err)
                           }
                           })
  }

  updateChannel(channel,handler) {
    this.props.putChannel(channel, (response, err) => {
                           if (!err) {
                            this.setState({channel:response})
                            this.channelCreated(channel)
                           }
                           if (handler) {
                            handler(response, err)
                           }
                           })
  }

  channelCreated(channel) {
    const channelsTitles = {}
    channelsTitles[channel.id] = this.headerForChannel(channel)
    this.props.dispatch(actions.addBreadcrumbsRouteTitles({'channel':channelsTitles}))

    this.setTopbarButtons(false)
  }

  // Dialog

  handleOpenDeleteChannelDialog() {
    this.setState({
      deleteChannelDialogVisible: true
    });
  }

  handleCloseDialogs() {
    this.setState({
      deleteChannelDialogVisible: false
    });
  }

  // Helpers

  goBack() {
    const pathComponents = this.props.location.pathname.split("/");
    pathComponents.splice(pathComponents.length-2, 2);
    const path = pathComponents.join("/")
    this.context.router.push(path);
  }

  cloneChannel(channel) {
    let newChannel = {};
    for (var key in channel) {
      if (channel.hasOwnProperty(key)) {
        if (channel[key] instanceof Object) {
          newChannel[key] = {...channel[key]}
        }
        else {
          newChannel[key] = channel[key]
        }
      }
    }
    return newChannel
  }

}

export default connect.defaults(connectDefault)(props => {
  return {
    fetchChannel: (channelType = props.channelType) => ({
      channel: {
        ignore_error: true,
        title: 'Fetch Channel',
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        url:`${props.ahBaseUrl}/channels/${channelType}`,
        refreshing: true, force: true
      }
    }),
    postChannel: (channel, handler) => ({
      postChannelResponse: {
        title: 'Create Channel',
        dispatch: props.dispatch,
        handler: handler,
        appJWT: props.appJWT,
        url: `${props.ahBaseUrl}/channels`,
        refreshing: true, force: true,
        method: 'POST',
        body: channel
      }
    }),
    putChannel: (channel, handler) => ({
      putChannelResponse: {
        title: 'Update Channel',
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        handler: handler,
        url: `${props.ahBaseUrl}/channels/${channel.id}`,
        refreshing: true, force: true,
        method: 'PUT',
        body: channel
      }
    }),
    deleteChannel: (channel, handler) => ({
      deleteChannelResponse: {
        title: 'Delete Channel',
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        handler: handler,
        url: `${props.ahBaseUrl}/channels/${channel.id}`,
        refreshing: true, force: true,
        method: 'DELETE'
      }
    }),
    fetchChannelProviders: (handler) => ({
      fetchChannelProvidersResponse: {
        title: 'Fetch Channel Providers',
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        handler: handler,
        url:`${props.ahBaseUrl}/channeltypes/${props.channelType}/providers`
      }
    }),
    channelAPI: (providerId, api, body, handler) => ({
      channelAPIResponse: {
        title: 'Channel API',
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        handler: handler,
        url: `${props.ahBaseUrl}/api/${providerId}/${api}`,
        force: true,
        method: 'POST',
        body: body
      }
    }),
    fetch: (title, url, handler) => ({
      fetchResponse: {
        title: title,
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        handler: handler,
        url:url,
        refreshing: true, force: true
      }
    }),
  }
})(ChannelPage)



// WEBPACK FOOTER //
// ./src/containers/ChannelPage.js